import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';
import i18n from '../translations/i18n';

const propTypes = {
  comment: PropTypes.any,
  onConfirm: PropTypes.func,
  isModify: PropTypes.any,
  t: PropTypes.func,
  onCancel: PropTypes.func,
  open: PropTypes.bool,
};

const defaultProps = {
  initialComment: '',
  onConfirm: () => {},
  onCancel: () => {},
};

class NoteFormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentFieldValue: props.comment ? props.comment : '',
      showCommentFieldError: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.comment) {
      this.setState({
        commentFieldValue: nextProps.comment,
      });
    }
  }

  handleCommentFieldChange = (e) => {
    this.setState({
      commentFieldValue: e.target.value,
    });
  };

  confirm = () => {
    if (!this.state.commentFieldValue) {
      this.setState({
        showCommentFieldError: true,
      });
      return;
    }

    const values = {
      comment: this.state.commentFieldValue,
    };

    this.props.onConfirm(values);
  };

  render = () => {
    const title = this.props.isModify
      ? this.props.t('modify_note')
      : this.props.t('create_new_note_title');
    const errorText = this.state.showCommentFieldError ? this.props.t('field_required') : null;

    const actions = [
      <FlatButton label="Cancel" primary onTouchTap={this.props.onCancel} />,
      <FlatButton label="Confirm" primary keyboardFocused onTouchTap={this.confirm} />,
    ];

    return (
      <Dialog title={title} actions={actions} modal={false} open={this.props.open}>
        <TextField
          name="comment"
          errorText={errorText}
          maxLength="250"
          multiLine
          fullWidth
          rows={1}
          value={this.state.commentFieldValue}
          onChange={this.handleCommentFieldChange}
          hintText={this.props.t('note')}
          floatingLabelText={this.props.t('note')}
        />
      </Dialog>
    );
  };
}

NoteFormDialog.propTypes = propTypes;
NoteFormDialog.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(NoteFormDialog);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/NoteFormDialog.js